"use client"

import { Testimonial } from "@/components/terra/component/Testimonial/Testimonial"
import { SimpleCarousel } from "@/components/terra/component/SimpleCarousel/SimpleCarousel"

const FormatSectionTestimonials = (data: any) => {
  const formattedTestimonialItems =
    data?.data?.testimonialItemsCollection?.items?.map((testimonial: any) => {
      return {
        quote: testimonial?.longQuote,
        attributionName: testimonial?.author,
        attributionQualification: testimonial?.qualification,
      }
    })

  return (
    <div className="testimonials-section mx-auto px-10 pb-10">
      {formattedTestimonialItems && formattedTestimonialItems.length > 1 && (
        <SimpleCarousel>
          {formattedTestimonialItems.map((item: any, index: number) => {
            return (
              <div key={index}>
                <Testimonial {...item} />
              </div>
            )
          })}
        </SimpleCarousel>
      )}
      {formattedTestimonialItems && formattedTestimonialItems.length == 1 && (
        <Testimonial {...formattedTestimonialItems[0]} />
      )}
    </div>
  )
}
export default FormatSectionTestimonials
